import { render, staticRenderFns } from "./CoHeading.vue?vue&type=template&id=7a45172e&scoped=true&"
import script from "./CoHeading.vue?vue&type=script&lang=ts&"
export * from "./CoHeading.vue?vue&type=script&lang=ts&"
import style0 from "./CoHeading.vue?vue&type=style&index=0&id=7a45172e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a45172e",
  null
  
)

export default component.exports